/* eslint-disable import/no-unresolved */
/* eslint-disable import/namespace */
import axios from "axios";
import { GetBusinessData, hasToken, getToken } from "../Utils/utils/CommanFnc";
import defaultConfig from "./Config";
const axiosRequest = new Map();
//import * as actions from '../store/actions/index';
//axios.defaults.baseURL = 'http://35.154.104.156:3333/';
axios.defaults.baseURL = defaultConfig.host;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.timeout = 60000
axios.defaults.timeoutErrorMessage = "Time out please try again."
//window.logoPath = defaultConfig.host+"/"+defaultConfig.logoPath;

axios.interceptors.request.use(request => {
  const controller = new AbortController();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  request.cancelToken = source.token;
  request.signal = source.signal;
  if(axiosRequest.has(request.url)) {
    console.log(axiosRequest.get(request.url))
    axiosRequest.get(request.url).cancel();
    axiosRequest.delete(request.url);
  }
  axiosRequest.set(request.url, source);
  
  if(hasToken()){
    request.headers.common["Authorization"] = `Bearer ${getToken()}`
  }
  return request;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {  
  if(axiosRequest.has(response.config.url)) {
    axiosRequest.delete(response.config.url);
  }
  return response;
  
}, error => {
  console.log(error)
  // if(error.response.status === 401 && error.response.statusText === "Unauthorized"){
  //   //window.location.href = "/"
  // }
  return Promise.reject(error);
});
